import React, { memo } from "react"
import { useSetRecoilState, useRecoilValue } from "recoil"

import { ModeratorViewProps } from "../views/ModeratorView"
import { notificationNewMessagesSelector } from "../../../recoil/atoms/notification"
import useSoundAlert, { SoundType } from "../../../hooks/useSoundAlert"

const NewMessageNotification = React.memo(
  ({ targetTabIndex }: Pick<ModeratorViewProps, "targetTabIndex">) => {
    const { isEnabledNotificationNewMessages, isSoundNewMessage } =
      useRecoilValue(notificationNewMessagesSelector)
    const playSound = useSoundAlert()

    const setNotificationParams = useSetRecoilState(
      notificationNewMessagesSelector
    )

    React.useEffect(() => {
      // As this setting is for mod. mod as chat tab on index 1.
      const isChatTabActive = targetTabIndex === 1 && !window.document.hidden
      // plays for every message received, but should only play if chat tab not in focus or if browser tab not active
      if (
        isEnabledNotificationNewMessages &&
        isSoundNewMessage &&
        !isChatTabActive
      ) {
        playSound(SoundType.BLEEP)
        setNotificationParams({ isSoundNewMessage: false })
      }

      if (isEnabledNotificationNewMessages && isChatTabActive) {
        setNotificationParams({ isSoundNewMessage: false })
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEnabledNotificationNewMessages, isSoundNewMessage])
    return null
  }
)

export default memo(NewMessageNotification)
